/**
 * PaymentSummary — summary section container (①) of the payment detail page.
 *
 * Redux-connected: selects the mapped PaymentDetail from the paymentDetail
 * slice and composes the pure leaves (status line, identifiers, tags).
 * Renders nothing until a payment is loaded.
 */
import Container from '@cloudscape-design/components/container';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { useAppSelector } from 'src/store/hooks';
import { PaymentStatusLine } from './PaymentStatusLine';
import { PaymentDetailsView } from './PaymentDetailsView';
import { CorrelationTags } from './CorrelationTags';

export const PaymentSummary = () => {
  const detail = useAppSelector(state => state.paymentDetail.data);
  if (!detail) return null;

  return (
    <Container>
      <SpaceBetween size="m">
        <PaymentStatusLine
          id={detail.id}
          statusLabel={detail.statusLabel}
          statusType={detail.statusType}
          locationBadge={detail.locationBadge}
          paymentStatus={detail.paymentStatus}
        />
        <PaymentDetailsView
          identifiers={detail.identifiers}
          invoiceIds={detail.invoiceIds}
          reissue={detail.reissue}
        />
        <CorrelationTags tags={detail.correlationTags} />
      </SpaceBetween>
    </Container>
  );
};
